var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-mobile"},[_c('h3',[_vm._v(_vm._s(_vm.L('微信掃碼'))+"/"+_vm._s(_vm.L('长按识别二维码')))]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":require("@/assets/images/qcode/wx.jpg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa28f41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wx-mobile/index.vue
// module id = null
// module chunks = 